<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  
  <Sidebar variant="mobile" offcanvas_id="dashboardSidebarOffcanvas" />
<!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">
        <!-- Actions header (sticky within scrollable content) -->

        <!-- Table body -->
        <div class="visitor-card shadow border-primary">
          <div class="card-body bg-white pt-2">
          <div class="d-flex justify-content-between align-items-center sticky-top mb-2">

            <button
          class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu me-2 mb-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#dashboardSidebarOffcanvas"
          aria-controls="dashboardSidebarOffcanvas"
          aria-label="Open workspace menu"
        >
          <i class="bx bx-menu-alt-left fs-5"></i>
        </button>
            <button
              v-can-create.permission="'polls'"
                class="btn btn-primary btn-sm rounded-3 shadow-sm lh-sm ms-auto"
              @click="open_create_modal"
            >
              <span class="small text-xs d-flex align-items-center gap-1">
                Create Poll
              </span>
            </button>
          </div>


          <div class="row g-2 mb-3">
            <div
              v-for="card in poll_dashboard_cards"
              :key="card.label"
              class="col-6 col-md-4 col-xl"
            >
              <div class="dashboard-summary-card border rounded bg-white p-3 h-100 shadow-sm">
                <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                  <div class="d-flex flex-column justify-content-between h-100 min-w-0">
                    <div class="text-muted text-xxs fw-bold text-uppercase text-truncate">{{ card.label }}</div>
                    <div class="fw-bold text-dark h5 mb-0 mt-2">{{ card.value }}</div>
                  </div>
                  <span class="portal-dashboard-card-icon rounded-circle d-inline-flex align-items-center justify-content-center bg-light border flex-shrink-0">
                    <i class="bi" :class="[`text-${card.tone}`, card.icon]"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          
       
          <!-- table -->
           <div v-show="isLoading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Poll List...</p>
            </div>
            <div v-show="!isLoading">
          <div class="table-responsive">
            <table id="poll-table" class="table align-middle table-striped table-borderless mb-0">
              <thead class="btn-primary text-white ">
                <tr>
                  <th class="text-xxs fw-light">No.</th>
                  <th class="text-xxs fw-light text-center">Poll Name</th>
                  <th class="text-xxs fw-light text-center">Poll Questions</th>
                  <th class="text-xxs fw-light text-center">Actions</th>
                </tr>
              </thead>

              <tbody>
                <!-- Apply text-xxs at the row level for all cells -->
                <tr v-for="(poll, index) in polls" :key="poll.id" class="border-bottom text-xxs">
                  <!-- Number -->
                  <td class="text-center">
                    <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 text-xxs">
                      {{ index + 1 }}
                    </span>
                  </td>

                  <!-- Poll Name -->
                  <td class="text-center">
                    <div class="text-xxs">{{ poll.name }}</div>
                  </td>

                  <!-- Type -->
                  <td class="text-center">

                    <div v-for="(question, index) in poll.poll_questions" :key="question.id" class="chip chip-info text-xxs">
                      {{ question.question.question }}
                    </div>
                  </td>

                  <!-- Actions -->
                  <td class="text-center">
                    <div class="d-flex justify-content-center gap-1">
                      <button
                        type="button"
                        class="btn btn-light btn-sm rounded-3 text-primary border"
                        @click="open_poll_responses_modal(poll)"
                      >
                        <span class="text-xxs">View</span>
                    </button>

                      <button
                        class="btn btn-light btn-sm rounded-3 text-success border"
                        @click="open_edit_modal(poll)"
                      >
                        <span class="text-xxs">Edit</span>
                      </button>

                      <button
                        class="btn btn-light btn-sm rounded-3 text-danger border"
                        @click="delete_poll(poll.id)"
                      >
                        <span class="text-xxs">Delete</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          </div>
          </div>
        </div>

      </div>

    </div> <!-- /row -->
  </div> <!-- /container-fluid -->

</div> <!-- /app shell -->


<!-- Create / Edit Poll Modal -->
 <teleport to="body">
<div class="modal fade" id="create_poll" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-center text-xxs fw-500 mb-0 w-100" id="exampleModalLabel">
            {{ isEditMode ? 'Edit Poll' : 'Create a Poll' }}
          </p>

          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
      </div>
 <form @submit.prevent="poll_id ? update_poll() : submit_poll_form()">
  <div class="modal-body">
                        <label class="form-label text-xxs fw-500">Poll Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control form-control-lg text-xxs rounded" id="poll_name"
                            placeholder="Poll Name" v-model="poll_name" />
                        <p v-if="errors.poll_name" class="text-danger text-xxs mt-1">
                            {{ errors.poll_name }}
                        </p>
                        <label class="form-label text-xxs fw-500">Enter Question <span
                                class="text-danger">*</span></label>
                        <input type="text" class="form-control form-control-lg text-xxs rounded"
                            placeholder="What is your question?" v-model="poll_question" />
                        <p v-if="errors.poll_question" class="text-danger text-xxs mt-1">
                            {{ errors.poll_question }}
                        </p>
                        <label class="form-label text-xxs fw-500">Poll Options <span
                                class="text-danger">*</span></label>
                        <div v-for="(option, index) in options" :key="index" class="poll-option mb-2">
                            <div class="input-group">
                                <input type="text" class="form-control form-control-lg text-xxs rounded"
                                    :placeholder="`Answer ${index + 1}`" v-model="option.value"
                                    @input="on_input(index)" />
                                <p v-if="errors.poll_answer" class="text-danger text-xxs mt-1">
                                    {{ errors.poll_answer }}
                                </p>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end">
                            <button type="submit" class="btn btn-primary btn-sm text-xxs rounded">
                                {{ poll_id ? 'Update' : 'Create' }} Poll
                            </button>
                            <button v-if="poll_id" type="button" class="btn btn-sm btn-danger text-xxs rounded ms-2"
                                @click="cancelEditPoll">
                                Cancel
                            </button>
                        </div>

                        </div>
                    </form>
    </div>
  </div>
</div>
</teleport>

<teleport to="body">
<div class="modal fade" id="view_poll_responses_modal" tabindex="-1" aria-labelledby="viewPollResponsesLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-center text-xxs fw-500 mb-0 w-100" id="viewPollResponsesLabel">
          {{ selected_view_poll?.name || 'Poll Responses' }}
        </p>
        <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body modal-body-scroll">
        <p v-if="selected_view_poll?.description" class="text-muted text-xxs mb-3">{{ selected_view_poll.description }}</p>
        <div v-for="(question, index) in get_poll_response_questions(selected_view_poll)" :key="question.id || index" class="border rounded bg-light p-3 mb-3">
          <p class="fw-bold text-xxs mb-2">{{ index + 1 }}. {{ get_poll_response_question_text(question) }}</p>
          <div v-if="question.answers && question.answers.length">
            <div v-for="(answer, answerIndex) in question.answers" :key="answer.id || answerIndex" class="border-top py-2 text-xxs">
              <span class="fw-semibold">{{ get_response_user_name(answer) }}:</span>
              <span class="text-muted">{{ get_poll_response_answer_text(answer) }}</span>
            </div>
          </div>
          <p v-else class="text-muted text-xxs mb-0">No votes yet.</p>
        </div>
        <p v-if="!get_poll_response_questions(selected_view_poll).length" class="text-muted text-xxs mb-0">No questions found.</p>
      </div>
    </div>
  </div>
</div>
</teleport>


